import { FilterItem, FilterItemOperator } from '@mm/state/model/AudiencesModel';
import { selectAudienceVariables } from '@mm/state/selectors/audienceSelector';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AudienceFilterItemInput } from '../../../../../../common/components/AudienceFilterItemInput/AudienceFilterItemInput';
import { getFormattedDisplayValue } from '../../../../contacts/components/audienceFilters/helpers';
import { FilterBarItemContentProps } from './FilterBarItem';
import { FilterBarItemEditContainerButtons } from './FilterBarItemEditContainerButtons';

const OPERATOR_CAPTIONS: Record<FilterItemOperator, string> = {
  contains: 'contains',
  does_not_contain: 'does not contain',
  ends_with: 'ends with',
  equal: 'equals',
  greater_than: 'is greater than',
  less_than: 'is less than',
  not_equal: 'does not equal',
  starts_with: 'starts with',
};

export const FilterBarVariableFilter = ({
  editing,
  filter,
  onCancelEdit,
  onStartEdit,
  onUpdate,
  styles,
  className,
}: FilterBarItemContentProps<FilterItem>) => {
  const audienceVariables = useSelector(selectAudienceVariables);
  const variable = audienceVariables.find(
    v =>
      v.variableType === filter.variableType &&
      v.variableId === filter.variableId,
  );
  const [filterUnderEdit, setFilterUnderEdit] = useState<FilterItem>();
  useEffect(() => {
    if (!editing) {
      setFilterUnderEdit(undefined);
      return;
    }
    setFilterUnderEdit({ ...filter, variable: variable?.name || '' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editing]);

  const onDone = () => onUpdate(filterUnderEdit);

  return (
    <>
      {editing && filterUnderEdit && (
        <div className={classNames(styles.editContainer, className)}>
          <strong>Filter by attribute</strong>
          <AudienceFilterItemInput
            chipTagItems
            css={{
              section: styles.audienceFilterItemInputSection,
              fieldTitle: styles.audienceFilterItemInputFieldTitle,
              selectActiveItem: styles.audienceFilterItemInputSelectActiveItem,
              suggestionsContainer:
                styles.audienceFilterItemInputSuggestionsContainer,
              valueInput: styles.audienceFilterItemInputValueInput,
              valueButton: styles.audienceFilterItemInputValueButton,
              valueListing: styles.audienceFilterItemInputValueListing,
              valueTagItem: styles.tag,
            }}
            filter={filterUnderEdit}
            setFilter={setFilterUnderEdit}
          />
          <FilterBarItemEditContainerButtons
            className={styles.editContainerButtons}
            disableDone={
              !filterUnderEdit.operator || !filterUnderEdit.value.length
            }
            onDone={onDone}
            onCancelEdit={onCancelEdit}
          />
        </div>
      )}

      <div onClick={onStartEdit} className={styles.content}>
        <strong>Attribute:</strong>&nbsp;
        {variable ? variable.name : <em>Select attribute and value</em>}
        &nbsp;
        {filter.operator && (
          <>
            <span>{OPERATOR_CAPTIONS[filter.operator]}</span>&nbsp;
            {Array.isArray(filter.value)
              ? filter.value.map(getFormattedDisplayValue).join(', ')
              : getFormattedDisplayValue(filter.value)}
          </>
        )}
      </div>
    </>
  );
};
